import { connect } from 'react-redux';
import { getCollectionData } from '../../store/orm/Collection/selectors';

export const withCollection = connect((state, { match }) => ({
  collection: getCollectionData(state, match.params.collectionId),
}));
